var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowReplay = function SvgArrowReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D98FF",
    d: "M11.396 1.966a.857.857 0 0 1 1.212 1.212l-1.114 1.115h.017V6.01l1.097 1.099a.857.857 0 1 1-1.212 1.212L8.825 5.75a.857.857 0 0 1 0-1.213z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D98FF",
    strokeLinecap: "round",
    strokeWidth: 1.714,
    d: "M4.287 12.858a7.7 7.7 0 0 0 2.26 5.455A7.7 7.7 0 0 0 12 20.573a7.7 7.7 0 0 0 5.455-2.26 7.7 7.7 0 0 0 2.26-5.455 7.7 7.7 0 0 0-2.26-5.455 7.7 7.7 0 0 0-5.455-2.26 7.7 7.7 0 0 0-1.714.192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D98FF",
    d: "M12.605 1.965a.857.857 0 0 0-1.212 0L8.822 4.536a.857.857 0 0 0 0 1.213l2.571 2.571a.857.857 0 0 0 1.212-1.212l-1.09-1.092q.24-.015.484-.016c1.894 0 3.607.766 4.849 2.008a6.83 6.83 0 0 1 2.008 4.849 6.83 6.83 0 0 1-2.008 4.849 6.83 6.83 0 0 1-4.849 2.008 6.83 6.83 0 0 1-4.849-2.008 6.83 6.83 0 0 1-2.008-4.85.857.857 0 1 0-1.714 0c0 2.367.96 4.512 2.51 6.062A8.55 8.55 0 0 0 12 21.428c2.367 0 4.51-.96 6.061-2.51a8.55 8.55 0 0 0 2.51-6.061c0-2.367-.96-4.511-2.51-6.061A8.55 8.55 0 0 0 12 4.286c-.166 0-.346-.003-.509.006l1.114-1.115a.857.857 0 0 0 0-1.212"
  })));
};
export default SvgArrowReplay;